import React from 'react';
import Plot from "react-plotly.js";
import { Box, Paper, Typography, Divider } from "@mui/material";

const CampaignImpressionLineChart = ({ data }) => {

  return (
    <Box mt={3}>
      {Object.entries(data).map(([billboardId, billboardData]) => {
        const timeSeries = billboardData.time_series || [];

        // Extract arrays for plot
        const dates = timeSeries.map((entry) => entry.date);
        const impressions = timeSeries.map((entry) => entry.avg_impressions);
        const rollingAverages = timeSeries.map((entry) => entry.rolling_avg_impressions);

        return (
          <Paper
            key={billboardId}
            elevation={4}
            sx={{ p: 3, mb: 4, borderRadius: 3, backgroundColor: "#f9f9f9" }}
          >
            <Typography
              variant="h6"
              sx={{ mb: 2, color: "primary.main", fontWeight: 600 }}
            >
              Billboard: {billboardId} - {billboardData.location} ({billboardData.height} x {billboardData.width})
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Plot
              data={[
                {
                  x: dates,
                  y: impressions,
                  type: "scatter",
                  mode: "lines+markers",
                  name: "Daily Impressions",
                  line: { color: "steelblue" },
                },
                {
                  x: dates,
                  y: rollingAverages,
                  type: "scatter",
                  mode: "lines+markers",
                  name: "7-Day Rolling Avg",
                  line: { color: "tomato", dash: "dash" },
                },
              ]}
              layout={{
                title: "Daily Impression Trends",
                xaxis: {
                  title: "Date",
                  tickangle: -45,
                  type: "category",
                },
                yaxis: {
                  title: "Number of Impressions",
                },
                margin: { t: 40, l: 50, r: 20, b: 60 },
                paper_bgcolor: "#fff",
                plot_bgcolor: "#fff",
                legend: { orientation: "h", y: -0.3 },
              }}
              useResizeHandler
              style={{ width: "100%", height: "100%" }}
              config={{ displayModeBar: true, displaylogo: false }}
            />
          </Paper>
        );
      })}
    </Box>
  );
};

export default CampaignImpressionLineChart;